import { Text, Stack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useProductsAdded } from '../../../../hooks';

interface ProductsResumeCartProps {}

export const ProductsResumeCart: React.FC<ProductsResumeCartProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { productCartCount, productAssetsCount, productCartTotalAvailableBalance } =
    useProductsAdded();

  const textVariant = isMobile ? 'regular' : 'bold';

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      space={{ base: Spacing['stack.nano'] }}
      px={Spacing['inline.xxs']}
      py={Spacing['inline.xxxs']}
      borderRadius={BoxRadius.sm}
      alignItems="center"
      justifyContent="space-between"
      bgColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="space-between"
        w={{ base: 'full', sm: 'container' }}
        space={{ base: Spacing['inline.nano'], sm: Spacing['inline.xs'] }}>
        <Stack
          direction={{ base: 'row', sm: 'column' }}
          justifyContent="space-between"
          w={{ base: 'full', sm: 'container' }}
          space={Spacing['inline.quarck']}>
          <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Produto
          </Text>
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.black">
            {productCartCount} produto(s)
          </Text>
        </Stack>
        <VStack
          direction={{ base: 'row', sm: 'column' }}
          w={{ base: 'full', sm: 'container' }}
          space={Spacing['inline.quarck']}
          justifyContent="space-between">
          <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Ativos adicionados
          </Text>
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {productAssetsCount} ativo(s)
          </Text>
        </VStack>
      </Stack>
      <Stack
        space={Spacing['inline.nano']}
        direction={{ base: 'row', sm: 'column' }}
        alignItems={{ base: 'center', sm: 'flex-start' }}
        justifyContent="space-between"
        w={{ base: 'full', sm: 'container' }}>
        <Text variant={textVariant} fontSize={Typography['fontsize.md']} color="neutral.darkest">
          Total do investimento
        </Text>
        <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.black">
          {productCartTotalAvailableBalance.totalFormatted}
        </Text>
      </Stack>
    </Stack>
  );
};
